/**
 * author：Caroline
 * date: 2019-10-28
 * desc: 根据不同的域名展示对应的logo，采用全局混合，
 *
 * hvyogo.com      慧用工
 * hvyogo.com.cn   会用工
 * hvyogo.net      汇用工
 * hvyogo.cn       惠用工
 * */

import Vue from "vue";

Vue.mixin({
  data() {
    return {
      whichAddress: "hvyogo.com"
    };
  },

  methods: {
    getSiteAddress() {
      this.whichAddress = window.location.hostname;
      // console.log('address,', this.whichAddress);

      let pathTemp = window.location.hash;
      let path = pathTemp.substring(1, pathTemp.length);
      // console.log(path.indexOf('/mExtensionPage'),"xiujei");

      let whichHui = ""; // hui 字
      let whichIcp = "湘ICP备2022006180号"; // icp备案号
      let whichCompName = "湖南慧用工信息技术有限公司"; // 公司名称
      // let policeText = true; // 是否有京网备案号
      let policeText = "京公网安备11010502053855"; // 是否有京网备案号
      let policeUrl =
        "https://beian.mps.gov.cn/#/query/webSearch?code=11010502053855";
      let companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层"; // 公司地址

      if (
        this.whichAddress === "www.hvyogo.com" ||
        this.whichAddress === "b.hvyogo.com"
      ) {
        // 慧
        whichHui = "hui15";
        whichIcp = "湘ICP备2022006180号";
        whichCompName = "湖南慧用工信息技术有限公司";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress === "www.hvyogo.com.cn" ||
        this.whichAddress === "b.hvyogo.com.cn"
      ) {
        // 会
        whichHui = "hui6";
        whichIcp = "湘ICP备2022006180号";
        whichCompName = "湖南慧用工信息技术有限公司";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress === "www.hvyogo.net" ||
        this.whichAddress === "b.hvyogo.net"
      ) {
        // 汇
        whichHui = "hui5";
        whichIcp = "湘ICP备2022006180号";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
        whichCompName = "湖南慧用工信息技术有限公司";
      } else if (
        this.whichAddress === "www.hvyogo.cn" ||
        this.whichAddress === "b.hvyogo.cn"
      ) {
        // 惠
        whichHui = "hui12";
        whichIcp = "湘ICP备2022006180号";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
        whichCompName = "湖南慧用工信息技术有限公司";
      } else if (this.whichAddress === "www.hiqifu.com") {
        // 海服
        whichHui = "hui15";
        whichIcp = "琼ICP备20000995号";
        policeText = "";
        policeUrl = "";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress === "www.hvcin.com" ||
        this.whichAddress === "hvcin.com"
      ) {
        // 慧薪
        whichHui = "hui15";
        whichIcp = "琼ICP备20000951号";
        policeText = "京公网安备11010502053855";
        whichCompName = "海南慧薪科技有限公司"; //慧薪
        policeUrl =
          "https://beian.mps.gov.cn/#/query/webSearch?code=11010502053855";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress === "www.jxhvyogo.com" ||
        this.whichAddress === "b.jxhvyogo.com" ||
        this.whichAddress === "jxhvyogo.com"
      ) {
        // 江西慧用工
        whichIcp = "赣ICP备20006782号-1";
        whichHui = "hui15";
        whichCompName = "江西慧用工企业服务有限公司";
        policeText = "";
        policeUrl = "";
        companyAddress = "江西省九江市共青城市市民服务中心4号楼3层";
      } else if (
        this.whichAddress === "www.hvyosv.com" ||
        this.whichAddress === "b.hvyosv.com"
      ) {
        // 山东慧优税
        whichIcp = "鲁ICP备20000938号";
        whichHui = "hui15";
        whichCompName = "山东慧优税信息技术服务有限公司";
        policeText = "";
        policeUrl = "";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress === "www.jxhifu.com" ||
        this.whichAddress === "jxhifu.com" ||
        this.whichAddress === "b.jxhifu.com"
      ) {
        // 江西海服
        whichIcp = "赣ICP备2020013630号";
        whichHui = "hui15";
        whichCompName = "江西海服科技有限公司";
        policeText = "京公网安备11010502053855";
        policeUrl =
          "https://beian.mps.gov.cn/#/query/webSearch?code=11010502053855";
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层";
      } else if (
        this.whichAddress == "hnhvyogo.com" ||
        this.whichAddress === "www.hnhvyogo.com"
      ) {
        // 湖南慧用工服务有限公司
        whichHui = "hui15";
        whichCompName = "湖南慧用工服务有限公司";
        whichIcp = "湘ICP备2021002813号";
        policeText = "湘公网安备43020002000095";
        policeUrl = "https://beian.mps.gov.cn/#/query/webSearch?code=43020002000095";
        companyAddress = "湖南省醴陵市经济开发区华瓷汇总部大楼B栋2楼211-212室";
      } else if (
        this.whichAddress == "www.hyhvyogo.com" ||
        this.whichAddress === "hyhvyogo.com" ||
        this.whichAddress === "b.hyhvyogo.com"
      ) {
        // 衡阳慧用工服务有限公司
        whichHui = "hui15";
        whichCompName = "衡阳慧用工服务有限公司";
        whichIcp = "湘ICP备2021002814号";
        policeText = "京公网安备11010502053855";
        policeUrl =
          "https://beian.mps.gov.cn/#/query/webSearch?code=11010502053855";

        companyAddress = "湖南省衡阳市珠晖区衡州大道1号衡阳丽波国际酒店三楼";
      } else if (
        this.whichAddress == "www.hnhifu.com" ||
        this.whichAddress === "hnhifu.com"
      ) {
        // 湖南海服服务有限公司
        whichHui = "hui15";
        whichCompName = "湖南海服科技有限公司";
        whichIcp = "湘ICP备2021002814号";
        policeText = "";
        policeUrl = "";
        companyAddress = "湖南省津津市高新技术产业开发区互联网产业园办公楼一楼";
      } else if (
        this.whichAddress == "www.hyhaifu.com" ||
        this.whichAddress === "hyhaifu.com" ||
        this.whichAddress === "b.hyhaifu.com"
      ) {
        // 湖南海服服务有限公司
        whichHui = "hui15";
        whichCompName = "衡阳海服科技有限公司";
        whichIcp = "湘ICP备2021010316号";
        policeText = "";
        policeUrl = "";
        companyAddress = "湖南省衡阳市珠晖区衡州大道1号衡阳丽波国际酒店三楼";
      } else if (this.whichAddress == "www.zkhvyogo.com") {
        // 河南慧用工
        whichHui = "hui15";
        whichCompName = "河南慧用工企业服务有限公司";
        whichIcp = "豫ICP备2023000892号";
        policeText = "";
        policeUrl = "";
        companyAddress = "河南省周口市文昌大道东段招商大厦615室";
      } else if (this.whichAddress == "www.zzhvyogo.com") {
        // 郑州慧用工
        whichHui = "hui15";
        whichCompName = "郑州慧用工企业服务有限公司";
        whichIcp = "豫ICP备2023000950号";
        policeText = "";
        policeUrl = "";
        companyAddress =
          "河南省郑州市郑东新区龙湖外环路66号龙兴嘉苑一号院10号楼一楼龙湖企业服务中心164室";
      } else {
        whichHui = "hui15";
        whichIcp = "湘ICP备2022006180号";
      }

      if (
        path.indexOf("/mExtensionPage") !== -1 ||
        path.indexOf("/extensionPage") !== -1
      ) {
        companyAddress = "北京市朝阳区酒仙桥路甲12号科技大厦4层"; //推广页面的公司地址特定
      }

      return {
        whichHui: whichHui,
        whichIcp: whichIcp,
        whichCompName: whichCompName,
        policeText: policeText,
        policeUrl: policeUrl,
        companyAddress: companyAddress
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/common/mixin.js